var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-accordion',[_c('header',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Toileting")]),_c('section',{attrs:{"slot":"content"},slot:"content"},[_c('toileting-section')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }